module.exports = __webpack_public_path__ + "static/img/web.5b5c50e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/web.png
// module id = jUFd
// module chunks = 0